var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.appointment
    ? _c(
        "div",
        {
          staticClass: "fixed z-50 pin overflow-auto bg-modal",
          class: _vm.active ? "block" : "hidden"
        },
        [
          _c(
            "div",
            { staticClass: "shadow max-w-sm mx-auto mt-24 px-4 md:px-0" },
            [
              _c("div", { staticClass: "bg-white rounded-t p-6" }, [
                _c(
                  "div",
                  { staticClass: "text-center text-grey-dark leading-normal" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "To_cancel_the_appointment_call_the_doctor_via_X",
                            { phoneNumber: _vm.appointment.officePhone }
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex md:hidden border-t items-center" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "block text-center bg-white rounded-bl w-1/2 border-r py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-black",
                      on: { click: _vm.close }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("Cancel")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "block text-center bg-white rounded-br w-1/2 py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-blue",
                      attrs: { href: "tel:" + _vm.appointment.officePhone }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("Call")) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "hidden md:flex border-t" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "bg-white rounded-b w-full text-grey-dark py-3 uppercase tracking-wide font-semibold text-sm hover:text-black",
                    on: { click: _vm.close }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Cancel")) +
                        "\n            "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7efe6fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7efe6fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/CancelAppointmentModal.vue
// module id = 776
// module chunks = 1